export default __webpack_public_path__ + "static/media/patent_printer.101276e6.jpg";